module.exports = __webpack_public_path__ + "media/images/lb/037-35aae12502cc0604231bb413395d6cbe.svg";